import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "submit"]

  validate() {
    const match = this.inputTarget.value.trim() === "DELETE"
    this.submitTarget.disabled = !match
  }
}
